import { light_offer_extended } from "../models/light_offer_extended";
import { differenceInDays } from "date-fns";

export default function isCouponNewCoupon(
  offer: light_offer_extended,
  now: Date,
): boolean {
  const isNewCoupon = offer.started_at
    ? differenceInDays(now, new Date(offer.started_at)) < 3
    : false;

  return isNewCoupon;
}
